import { createSlice } from '@reduxjs/toolkit';
import { downloadPDF } from '../../../rtk-apis/reports/downloadPdf';

const initialState = {
  status: '',
  result: null,
  msg: '',
  loading: false,
  error: '',
};

const downloadPdfSlice = createSlice({
  name: 'downloadPdfSlice',
  initialState,
  reducers: {
    clearDownloadPdfState: (state) => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(downloadPDF.pending, (state) => {
        state.loading = true;
      })
      .addCase(downloadPDF.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload.msg;
      })
      .addCase(downloadPDF.rejected, (state, action) => {
        state.loading = false;
        state.status = 'ERROR';
        state.result = null;
        state.msg = action.payload as string || 'Something went wrong!';
      });
  },
});

export default downloadPdfSlice.reducer;
export const { clearDownloadPdfState } = downloadPdfSlice.actions;
